import { Entity } from '@backstage/catalog-model';
import { MarkdownContent, StatusPending } from '@backstage/core-components';
import { Chip, Grid, makeStyles, Tooltip, Icon } from '@material-ui/core';

import { Annotations } from '../types';
import { AboutField } from './AboutField';
import { RelatedAccountsLinks } from './RelatedAccountLinks';

const useStyles = makeStyles({
  description: {
    wordBreak: 'break-word',
  },
});

/**
 * Props for {@link AboutContent}.
 *
 * @public
 */
export interface AboutContentProps {
  entity: Entity;
}

export function AboutContent(props: AboutContentProps) {
  const { entity } = props;
  const classes = useStyles();

  const annotations: Annotations | undefined = entity?.metadata
    ?.annotations as Annotations;
  const accountId: string | undefined =
    annotations?.['amazonaws.com/account-id'] ||
    annotations?.['azure.com/subscription-id'];

  const accountIdStatusMessage: string = 'Account creation is in progress.';

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={3}>
            <AboutField label="Type" gridSizes={{ xs: 12 }}>
              <MarkdownContent
                className={classes.description}
                content={(entity?.spec?.type as string) || 'No type'}
              />
            </AboutField>
          </Grid>
          <Grid item xs={3}>
            <AboutField label="Resource Id" gridSizes={{ xs: 12 }}>
              {accountId !== 'no-entry' ? (
                <MarkdownContent
                  className={classes.description}
                  content={accountId || 'No account id'}
                />
              ) : (
                <div style={{ marginTop: '10px' }}>
                  <Tooltip title={`${accountIdStatusMessage}`}>
                    <Icon>
                      <StatusPending />
                    </Icon>
                  </Tooltip>
                </div>
              )}
            </AboutField>
          </Grid>
          <Grid item xs={3}>
            <AboutField label="Workload Name" gridSizes={{ xs: 12 }}>
              <MarkdownContent
                className={classes.description}
                content={
                  entity?.metadata?.labels?.workload || 'No workload name'
                }
              />
            </AboutField>
          </Grid>
          <Grid item xs={3}>
            <AboutField label="Environment" gridSizes={{ xs: 12 }}>
              <MarkdownContent
                className={classes.description}
                content={
                  (entity?.metadata?.labels?.['pfg-env-type'] as string) ||
                  'No environment'
                }
              />
            </AboutField>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <AboutField
          label="Tags"
          value="No tags"
          gridSizes={{ xs: 12, sm: 6, lg: 4 }}
        >
          {(entity?.metadata?.tags || []).map(t => (
            <Chip key={t} size="small" label={t} />
          ))}
        </AboutField>
      </Grid>
      <Grid item xs={12}>
        <AboutField
          label="Related Accounts"
          // gridSizes={{ xs: 12, sm: 6, lg: 4 }}
        >
          <RelatedAccountsLinks />
        </AboutField>
      </Grid>
    </Grid>
  );
}
